// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__Z9Z4k","activeLink":"Header_activeLink__EDH3b"};